/**
 * Cambia el estado del navbar entre relativo y fijo según la posición de scroll
 * @param {Object} options - Opciones de configuración
 * @param {string} options.navSelector - Selector CSS del navbar
 * @param {string} options.targetSelector - Selector CSS de la sección hero
 * @param {Object} options.classesToAdd - Clases a añadir cuando el navbar está fijo
 * @param {Object} options.classesToRemove - Clases a quitar cuando el navbar está fijo
 * @param {boolean} options.useTransition - Si se deben usar transiciones (por defecto: true)
 */
/**
 * Cambia el estado del navbar entre relativo y fijo según la posición de scroll
 * con transiciones mejoradas y efectos suaves.
 */
export function scrollToggleFixed({
                                      navSelector,
                                      targetSelector,
                                      classesToAdd = {
                                          fixed: ['fixed', 'top-0', 'left-0', 'w-full', 'z-50', 'py-2','shadow-md', 'translate-y-0'],
                                          relative: ['relative']
                                      },
                                      classesToRemove = {
                                          fixed: ['relative', '-translate-y-1'],
                                          relative: ['fixed', 'top-0', 'left-0', 'w-full', 'z-50', 'py-2', 'shadow-md', 'translate-y-0']
                                      },
                                      useTransition = true
                                  }) {
    const navbar = document.querySelector(navSelector);
    const target = document.querySelector(targetSelector);

    if (!navbar || !target) {
        console.error('No se encontró el navbar o la sección target');
        return;
    }

    // Añadir transiciones más refinadas si están habilitadas
    if (useTransition) {
        // Transiciones específicas y diferenciadas para propiedades individuales
        navbar.style.transition = `
            transform 0.4s cubic-bezier(0.215, 0.61, 0.355, 1),
            background-color 0.5s ease-in-out,
            padding 0.35s ease-out,
            box-shadow 0.4s ease
        `;
    }

    // Función para obtener la posición bottom del target
    const getTargetBottom = () => target.getBoundingClientRect().bottom;

    // Variable para almacenar el estado actual para evitar cambios innecesarios en el DOM
    let isFixed = false;

    // Función que actualiza las clases
    const updateNavbarClasses = () => {
        const shouldBeFixed = getTargetBottom() <= 0;

        // Solo actualizar si hay un cambio de estado
        if (shouldBeFixed !== isFixed) {
            isFixed = shouldBeFixed;

            if (shouldBeFixed) {
                // Para la transición a fijo, primero aplicamos una clase para un ligero efecto de entrada
                navbar.classList.add('-translate-y-1');

                // Pequeño retraso para crear efecto de entrada suave
                setTimeout(() => {
                    // Aplicar clases para estado fijo
                    classesToAdd.fixed.forEach(cls => navbar.classList.add(cls));
                    classesToRemove.fixed.forEach(cls => navbar.classList.remove(cls));
                }, 10);
            } else {
                // Para una transición más suave al retornar a relativo
                // Primero quitamos shadow y reducimos opacidad
                navbar.style.boxShadow = 'none';

                // Pequeño retraso para la transición secuencial
                setTimeout(() => {
                    // Aplicar clases para estado relativo
                    classesToAdd.relative.forEach(cls => navbar.classList.add(cls));
                    classesToRemove.relative.forEach(cls => navbar.classList.remove(cls));

                    // Restaurar propiedades después de la transición
                    setTimeout(() => {
                        navbar.style.boxShadow = '';
                    }, 300);
                }, 10);
            }
        }
    };

    // Comprobación inicial
    updateNavbarClasses();

    // Listener de scroll con throttle para mejorar el rendimiento
    let ticking = false;
    window.addEventListener('scroll', () => {
        if (!ticking) {
            window.requestAnimationFrame(() => {
                updateNavbarClasses();
                ticking = false;
            });
            ticking = true;
        }
    });

    // También actualizar al redimensionar la ventana
    window.addEventListener('resize', updateNavbarClasses);

    // Devolver función para eliminar listeners si es necesario
    return () => {
        window.removeEventListener('scroll', updateNavbarClasses);
        window.removeEventListener('resize', updateNavbarClasses);
    };
}
